module.exports = __webpack_public_path__ + "static/media/correia.d639b00f.webp";